import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Paginated } from '@core/models/IApi';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { NewsletterPost, ReleaseInfoDTO } from '../models/newsletter.types';

@Injectable({
    providedIn: 'root',
})
export class NewsletterHttpService {
    private readonly http = inject(HttpClient);
    private readonly translate = inject(TranslateService);
    private readonly URL = `${environment.api_base}/admin/release`;
    private readonly URL_BY_ID = `${this.URL}/@id`;

    private currentLang(): string {
        return this.translate.currentLang || this.translate.defaultLang || 'en';
    }

    get(): Observable<Paginated<NewsletterPost[]>> {
        const url = this.URL;
        const params: Params = {
            sort: 'released_at_desc',
        };
        const lang = this.currentLang();
        return this.http.get<Paginated<ReleaseInfoDTO[]>>(url, { params }).pipe(
            map(({ data, ...rest }) => ({
                data: data.map(item => new NewsletterPost(item, lang)),
                ...rest,
            }))
        );
    }
    getById(id: number): Observable<NewsletterPost> {
        const url = this.URL_BY_ID.replace('@id', id.toString());
        const lang = this.currentLang();
        return this.http.get<ReleaseInfoDTO>(url).pipe(map(data => new NewsletterPost(data, lang)));
    }
}
